<template>
  <section class="product-shop spad">
    <div class="container" v-if="store != false">
      <div class="row">
        <div class="cover-photo" v-if="store.cover_photo !== null">
          <img
            class="cover-photo-picture"
            :src="config.storageUrl + store.cover_photo"
          />
        </div>
      </div>
      <div class="row" style="margin-top:5%;">
        <div class="col-2" v-if="store.picture !== null">
          <img class="thumbnail" :src="config.storageUrl + store.picture" />
        </div>
        <div class="col-10">
          <div class="store-name">
            <h3>{{ store.name }}</h3>
            <label v-if="store.products.length > 0" class="store-products"
              >{{ store.products.length }} {{ $t("sidebar.products") }}</label
            >
          </div>
          <div
            style="margin-top:2%;"
            v-if="store.description"
            class="store-description"
          >
            <p>
              {{ store.description }}
            </p>
          </div>
          <div class="row" style="margin-top:3%;">
            <a @click="show('user-pro-info')" class="contact-seller">{{
              $t("attr.contactDetails")
            }}</a>
            <a @click="show('contact-user')" class="contact-seller">{{
              $t("sentence.contactTheSeller")
            }}</a>
          </div>
        </div>
      </div>
      <contact-user-modal :user="store.user"></contact-user-modal>
      <client-pro-modal :user="store.user" :store="store"></client-pro-modal>
      <div class="row" style="margin-top:5%;">
        <div class="col-10 offset-2 card-body card-white">
          <div class="row">
            <ProductSingle
              v-for="product in store.products"
              v-bind:key="product.id"
              class="col-sm-10 col-md-6 col-lg-4"
              :product="product"
            />
          </div>
        </div>
      </div>
      <div class="alert alert-danger text-center" v-show="emptyProduct">
        {{ $t("sentence.noProductForThisCategory") }}
      </div>
    </div>
    <div class="container" v-else>
      <div class="row">
        <div class="col-8 offset-2 alert alert-danger text-center">
          {{ $t("sentence.storeNoLongerExists") }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from "@/config";
import ContactUserModalVue from "@/components/modals/ContactUserModal.vue";
import ClientProInformationModal from "@/components/modals/ClientProInformationModal";
// import TimerListProduct from "@/components/templates/TimerListProduct";
import ProductSingle from "@/components/templates/ProductSingle";

export default {
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.getStore(this.$route.params.id);
    }
  },
  data() {
    return {
      config: config,
      store: false,
      message: "",
      emptyProduct: false,
      ProductSingle,
    };
  },
  components: {
    ProductSingle,
    // TimerListProduct,
    "contact-user-modal": ContactUserModalVue,
    "client-pro-modal": ClientProInformationModal,
  },
  methods: {
    getStore(id) {
      var self = this;

      this.$axios({
        url: "store/" + id,
        method: "GET",
      })
        .then((response) => {
          if (response.data !== null) {
            self.store = response.data;
          }
        })
        .catch((err) => {
          console.log(err.data);
        });
    },
    show(modalName) {
      this.$modal.show(modalName);
    },
  },
};
</script>

<style>
.cover-photo {
  width: 100%;
}

.cover-photo-picture {
  position: relative;
  max-height: 270px;
  width: 100%;
  height: auto;
}

.contact-seller {
  color: #0654ba !important;
  text-decoration: none !important;
  margin-right: 3%;
  cursor: pointer;
}
.store-name {
  margin-right: -15px;
  margin-left: -15px;
}
.store-description {
  margin-right: -15px;
  margin-left: -15px;
}
</style>
